import { IconConfig, UIConfig } from '../models/appState';
import {
    Box,
    Check,
    Clock,
    Cog,
    Drill,
    FileCheck,
    FileDigitIcon,
    FileText,
    HardHatIcon,
    Info,
    MapPin,
    PocketKnife,
    ShieldHalf,
    SquarePenIcon,
    Truck,
    TruckIcon,
    Wrench,
    X,
} from 'lucide-react';
import OutlinedMoldIcon from '../components/icons/OutlinedMoldIcon';

// Explicit registry keeps configuration-driven icons tree-shakeable. Add new
// company/workflow icons here; icon.test.tsx checks every configured icon.
const lucideIcons: Record<string, React.ComponentType> = {
    Box,
    Check,
    Clock,
    Cog,
    Drill,
    FileCheck,
    FileDigitIcon,
    FileText,
    HardHatIcon,
    Info,
    MapPin,
    PocketKnife,
    ShieldHalf,
    SquarePenIcon,
    Truck,
    TruckIcon,
    Wrench,
    X,
};

// Map of custom icons
const customIcons = {
    OutlinedMoldIcon,
};

export const getIconComponent = (uiConfig: UIConfig): React.ComponentType | null => {
    return getDynamicIcon(uiConfig.icon);
};

export const getDynamicIcon = (iconConfig: IconConfig): React.ComponentType | null => {
    const { name, source } = iconConfig;
    if (source === 'lucide') {
        const IconComponent = Object.prototype.hasOwnProperty.call(lucideIcons, name) ? lucideIcons[name] : null;
        if (!IconComponent) {
            console.warn(`Lucide icon "${name}" not found`);
            return null;
        }
        return IconComponent;
    } else if (source === 'custom') {
        const IconComponent = (customIcons as any)[name];
        if (!IconComponent) {
            console.warn(`Custom icon "${name}" not found`);
            return null;
        }
        return IconComponent;
    } else {
        console.warn(`Unknown icon source "${source}"`);
        return null;
    }
}